import { render } from "./RegisterUserView.vue?vue&type=template&id=3ff666e6"
import script from "./RegisterUserView.vue?vue&type=script&lang=js"
export * from "./RegisterUserView.vue?vue&type=script&lang=js"

import "./RegisterUserView.vue?vue&type=style&index=0&id=3ff666e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__